

import ReactWebChat, { createDirectLine, type createStore } from 'botframework-webchat';
import React, { memo, useEffect, useMemo } from 'react';
import { appConfig } from '../../../utils/app.config';
import './WebChat.css';
import { useSelector } from 'react-redux';

type Props = Readonly<{
  className?: string | undefined;
  onFetchToken?: (() => void) | undefined;
  store: ReturnType<typeof createStore>;
  styleOptions: any;
  styleSet: any;
  token: string;
  sendMessage: boolean;
  setSendMessage?: ((value: boolean) => void);
  message: string;
  disabled?: boolean;
}>;

function WebChat({
  className = "react-web-chat",
  onFetchToken = () => { },
  store = {} as ReturnType<typeof createStore>, // default empty store
  styleOptions = {},
  styleSet = {},
  token = "",
  sendMessage = false,
  setSendMessage = () => { },
  message = '',
  disabled = false
}: Props) {
  console.log("----styleOptions:", styleOptions);

  const userProfile = useSelector((store: any) => store.login.loginDetails);
  console.log("----userProfile", userProfile);
  console.log("----userProfile.email:", userProfile.email);

  let domain = `${appConfig.baseUrl}/gwt/channels/v1.0`
  const directLine = useMemo(() => createDirectLine(
    {
      token: token,
      domain: domain,
      webSocket: false,
      pollingInterval: 5000
    } as any), [token]);

  useEffect(() => {
    onFetchToken?.();
  }, [onFetchToken]);
  // useEffect(() => {
  //   const setPlaceholder = () => {
  //     const input = document.querySelector(
  //       ".webchat__send-box-text-box__input",
  //     ) as HTMLInputElement;

  //     if (input) {
  //       input.placeholder = "SHIVAM SETH TESTING";
  //     }
  //   };

  //   // Initial call
  //   setPlaceholder();

  //   // Observe DOM changes
  //   const observer = new MutationObserver(setPlaceholder);

  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true,
  //   });

  //   return () => observer.disconnect();
  // }, []);
  useEffect(() => {
    setTimeout(() => {
      const input = document.querySelector(
        ".webchat__send-box-text-box__input",
      ) as HTMLInputElement;

      if (input) {
        input.placeholder = "Ask a question about your IT needs";
      }
    }, 1000);
  }, []);

  if (sendMessage && message) {
    const send = async () => {
      try {
        await directLine.postActivity({
          "attachments": [],
          "channelData": {
            "attachmentSizes": [],
            "clientActivityID": generateClientActivityID()
          },
          "text": message,
          "textFormat": "plain",
          "type": "message",
          "channelId": "webchat",
          "from": {
            "id": userProfile.email,
            "name": "",
            "role": "user"
          },
          "locale": "en-US"
        }).toPromise();
      } catch (error) {
        console.error('Error sending message:', error);
      }
    };
    send();
    setSendMessage(false);
  }

  return token ? (
    <ReactWebChat
      className={`${className || ''} web-chat`}
      directLine={directLine}
      store={store}
      userID={`${userProfile.email}`}
      styleOptions={styleOptions}
      disabled={disabled}
    />
  ) : (
    <div className={`${className || ''} connect-spinner`}>
      <div className="content">
        <div className="icon">
          <span className="ms-Icon ms-Icon--Robot" ></span>
        </div>
        <p>{'Please wait while we are connecting to the bot.'}</p>
      </div>
    </div>
  );
}

function generateClientActivityID(): string {
  const length = 10;
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

export default memo(WebChat);
